import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import DataSevices from "../Services/DataSevices";
import { useLocation } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardContent } from "../Components/card";
import { title } from "framer-motion/client";
import "moment/locale/en-gb";
import "./calendar.css"
import { LogOut } from "@emotion-icons/feather/LogOut";
import { Link, useNavigate } from "react-router-dom";
import { LOGOUT } from "../constants/Constants";
import { useAuth } from "./../context/AuthContext";

moment.locale("en-gb");
const localizer = momentLocalizer(moment);

const SingleDevDataWithCalUI = () => {
  const [eventsData, setEventsData] = useState([{ title: "Untitled" }]);
  const [japaAttendanceSingleDev, setJapaAttendanceSingleDev] = useState([]);
  const [alumniClassAttendanceSingleDev, setAlumniClassAttendanceSingleDev] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const { state } = useLocation();
    const navigate = useNavigate();
      const { login, logout } = useAuth();

  const email = state.email;
  const name = state.name;

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  // Process API response → events
  useEffect(() => {
    if (japaAttendanceSingleDev.length > 0 || alumniClassAttendanceSingleDev.length > 0) {
      const updatedEventsData = [];

      // 🟢 Japa Attendance
      japaAttendanceSingleDev.forEach((d) => {
        const dateFound = new Date(d.date);

        let japaObject;
        if (d.status === "PRESENT") {
          japaObject = {
            title: (
              <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                ✅ <b>Japa - </b>{d.duration}{"\n"}
                {d.joinLeaveTime}
              </div>
            ),
            allDay: true,
            start: new Date(dateFound.getFullYear(), dateFound.getMonth(), dateFound.getDate()),
            end: new Date(dateFound.getFullYear(), dateFound.getMonth(), dateFound.getDate()),
            color: "#16a34a", // green
            tags: ["PRESENT"],
          };
        } else {
          japaObject = {
            title: (
              <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                ❌ <b>Japa</b> {"\n"}
                {d.reason ? d.reason : "Click to add reason"}
              </div>
            ),
            allDay: true,
            start: new Date(dateFound.getFullYear(), dateFound.getMonth(), dateFound.getDate()),
            end: new Date(dateFound.getFullYear(), dateFound.getMonth(), dateFound.getDate()),
            color: "#ba3306ff", // red
            tags: ["ABSENT"],
          };
        }

        updatedEventsData.push(japaObject);
      });

      // 🔵 Alumni Class Attendance
      alumniClassAttendanceSingleDev.forEach((d) => {
        const dateFound = new Date(d.date);

        let alumniObject;
        if (d.status === "PRESENT") {
          alumniObject = {
            title: (
              <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                🎓 <b>Alumni Class - </b>{d.duration}{"\n"}
                {d.joinLeaveTime}
              </div>
            ),
            allDay: true,
            start: new Date(dateFound.getFullYear(), dateFound.getMonth(), dateFound.getDate()),
            end: new Date(dateFound.getFullYear(), dateFound.getMonth(), dateFound.getDate()),
            color: "#808d0bff", // blue
            tags: ["PRESENT"],
          };
        } else {
          alumniObject = {
            title: (
              <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                ❌ <b>Alumni Class</b> {"\n"}
               {d.reason ? d.reason : "Click to add reason"}
              </div>
            ),
            allDay: true,
            start: new Date(dateFound.getFullYear(), dateFound.getMonth(), dateFound.getDate()),
            end: new Date(dateFound.getFullYear(), dateFound.getMonth(), dateFound.getDate()),
            color: "#ba3306ff", // amber for absent alumni
            tags: ["ABSENT"],
          };
        }

        updatedEventsData.push(alumniObject);
      });

      setEventsData(updatedEventsData);
    }
  }, [japaAttendanceSingleDev, alumniClassAttendanceSingleDev]);


const fetchData = async () => {
      try {
        const response = await DataSevices.getJapaAttendanceDevoteeSingleData(
          email,
          selectedMonth + 1,
          selectedYear
        );
        setJapaAttendanceSingleDev(response.data);

        // fetching alumni class attendance
        const responseAlumni = await DataSevices.getAlumniClassAttendanceDevoteeSingleData(
          email,
          selectedMonth + 1,
          selectedYear
        );
        setAlumniClassAttendanceSingleDev(responseAlumni.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

  // Fetch data
  useEffect(() => {
    fetchData();
  }, [selectedMonth, selectedYear]);

  const handleSelect = async (event) => {
    let text = "";
    const date = event.start.toLocaleDateString("en-CA");
    // 🔹 Extract title text (your existing logic)
    if (event.title?.props?.children) {
      const flatten = (children) =>
        React.Children.toArray(children)
          .map((child) =>
            typeof child === "string"
              ? child
              : flatten(child.props?.children)
          )
          .join("");

      text = flatten(event.title.props.children);
    }

    // ❌ If PRESENT → just show info
    if (event.tags && event.tags.includes("PRESENT")) {
      alert(text);
      return;
    }

    // 🔥 Existing reason (if available from event)
    const existingReason = text.split("Japa")[1]?.trim() || "";

    // ✅ Prompt with default value
    const reason = window.prompt(
      existingReason.includes("Click") ? "Enter the reason" : "Update reason",
      existingReason || ""
    );

    // ❌ If user cancels
    if (reason === null) return;

    try {
      const payload = {
        date: date, // make sure this exists
        reason: reason,
        email: email
      };

      DataSevices.updateAbsentReason(payload)
              .then((res) => {
                  alert("Reason saved successfully");
                  fetchData()
                  navigate("/dashboard/devoteesJapa", { state: { email, name } });
              })
              .catch((err) => {
                console.log(err);
              });

    } catch (err) {
      console.error("Error saving reason:", err);
      alert("Failed to save reason");
    }
  };

const  handleLogout = async () => {
  sessionStorage.clear();
   logout()
  await fetch(LOGOUT, {
              method: "POST",
              credentials: "include",
            }).then(() => {
              navigate("/");
            })
};

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-100 via-purple-100 to-indigo-100 p-6 font-sans">
         <button
                   onClick={handleLogout}
                   style={{
                     position: "fixed",
                     top: "20px",
                     right: "20px",
                     zIndex: 1000,
                     background: "#ffffff",
                     border: "1px solid #e5e7eb",
                     borderRadius: "30px",
                     padding: "10px 16px",
                     cursor: "pointer",
                     boxShadow: "0 6px 15px rgba(0,0,0,0.8)",
                     transition: "all 0.3s ease",
                     display: "flex",
                     alignItems: "center",
                     gap: "8px",
                     fontWeight: "600",
                     color: "#374151"
                   }}
                   onMouseOver={(e) => {
                     e.currentTarget.style.transform = "scale(1.15)";
                     e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)";
                   }}
                   onMouseOut={(e) => {
                     e.currentTarget.style.transform = "scale(1)";
                     e.currentTarget.style.boxShadow = "0 6px 15px rgba(0,0,0,0.1)";
                   }}
                 >
                   <LogOut size={20} color="#ef4444" />
                   Logout
                 </button>
      <Card className="shadow-2xl rounded-2xl border border-purple-200 bg-gradient-to-br from-indigo-50 via-white to-purple-50">

        <CardHeader className="bg-gradient-to-r from-indigo-600 via-purple-500 to-pink-500 text-white rounded-t-2xl shadow-md p-8">
          <div className="text-center space-y-2">
            <CardTitle className="text-4xl font-bold tracking-wider drop-shadow-lg">
              Zoom Attendance Monthly Overview <p> {name} </p>
            </CardTitle>
          </div>
        </CardHeader>
        <CardContent className="p-4">
          <Calendar
            views={isMobile ? ["agenda"] : ["month"]}
            defaultView={isMobile ? "agenda" : "month"}
            selectable
            localizer={localizer}
            defaultDate={new Date()}
            date={new Date(selectedYear, selectedMonth, 1)}
            events={eventsData}
            style={{ height: "80vh" }}
            onSelectEvent={handleSelect}
            onNavigate={(date) => {
              setSelectedMonth(date.getMonth());
              setSelectedYear(date.getFullYear());
            }}
            eventPropGetter={(event) => {
              const backgroundColor = event.color || "#1154e3ff";
              return {
                className: "custom-calendar-event",
                style: { backgroundColor }
              };
            }}
            components={{
              event: EventComponent
            }}
            length={30}

          />

        </CardContent>
      </Card>
    </div>
  );
};

const EventComponent = ({ event }) => {
  if (!event) return null; // safety check
  return (
    <div
      style={{
        whiteSpace: "pre-wrap",   // respect \n
        wordBreak: "break-word",  // wrap long words
        fontSize: "12px",
        lineHeight: "1.2rem",
      }}
    >
      {event.title || "Untitled"}
    </div>
  );
};


export default SingleDevDataWithCalUI;
